module.exports = __webpack_public_path__ + "img/hr-branch-particle-11.06839ff5.png";